import React from 'react';
import c from 'classnames';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import LazyContext from '../../LazyLoadingImage/LazyContext';
import DuperbrowseContext from '../../Duperbrowse/DeviationDuperbrowseContext';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import AdoptableShopCard from '../../ShopCard/AdoptableShopCard';
import Slider, { SeeAllSlide } from '../../Slider';
import { GallectionSourceType } from './types';
import { EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID } from './consts';
import s from './ExhibitionistStrip.scss';
const ExhibitionistStrip = ({ moduleId })=>{
    const { moduleData } = useModuleData(moduleId);
    const { deviations, seeAllUrl, sourceType, hasMore } = moduleData;
    const isAdoptables = sourceType === GallectionSourceType.ADOPTABLE_FOR_SALE || sourceType === GallectionSourceType.ADOPTABLE_BOUGHT;
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement(Slider, {
        className: c(s['slider'], isAdoptables && s['slider-adoptables']),
        scrollBy: 0.5
    }, /*#__PURE__*/ React.createElement(DuperbrowseContext, {
        streamId: EXHIBITIONIST_STRIP_DUPERBROWSE_STREAMID,
        deviations: deviations
    }, deviations.map((deviation)=>{
        if (isAdoptables) {
            return /*#__PURE__*/ React.createElement(AdoptableShopCard, {
                key: deviation.deviationId,
                deviation: deviation,
                width: 328,
                withIndicators: false
            });
        }
        return /*#__PURE__*/ React.createElement(StandardThumb, {
            key: deviation.deviationId,
            className: s['slider-item'],
            deviation: deviation,
            height: 180,
            responsive: false
        });
    }), hasMore && seeAllUrl && /*#__PURE__*/ React.createElement(SeeAllSlide, {
        seeAllUrl: seeAllUrl
    }))));
};
ExhibitionistStrip.displayName = 'ExhibitionistStrip';
export default ExhibitionistStrip;
